import { render, staticRenderFns } from "./ProductionQuota.vue?vue&type=template&id=48fe5c92&scoped=true&"
import script from "./ProductionQuota.vue?vue&type=script&lang=js&"
export * from "./ProductionQuota.vue?vue&type=script&lang=js&"
import style0 from "./ProductionQuota.vue?vue&type=style&index=0&id=48fe5c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe5c92",
  null
  
)

export default component.exports